import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import './../../shared/rxjs-operators';
import { LogService, ApiService, CacheService, AppContext, Carrier } from './../../shared';

@Injectable()
export class CarriersSearchService {
  carriers: Observable<any>;
  public autoOn = false;
  public loaderOn = false;
  public noResult = false;

  constructor(private logger: LogService, private api: ApiService, private cache: CacheService, public app: AppContext) {
  }

  startSearch() {
    this.autoOn = true;
    this.loaderOn = true;
    this.noResult = false;
  }

  getCarriers(term: string): Observable<any> {
    this.logger.log('carriers-search.service', 'getCarriers', term);
    this.startSearch();
    // let cache = this.cache.get('carriers' + term);
    let promise = this.api.getApiClient().then(client => this.callGetCarriers(client, term));
    let server = Observable.fromPromise(promise);
    this.carriers = server;
    // this.carriers = Observable.concat(cache, server);
    // this.cache.updateCache('carriers' + term, this.carriers);

    return this.carriers;
  }

  callGetCarriers(apigClient: any, term: string): Promise<any> {
    this.logger.log('carriers-search.service', 'callGetCarriers', term);
    return new Promise((resolve, reject) => {
      let params = {};
      let body = {};
      let additionalParams = {
        headers: { 'Content-Type': 'application/json' },
        queryParams: { search: term }
      };
      try {
        apigClient.carriersGet(params, '', additionalParams)
        .then((result) => {
          this.logger.log('carriers-search.service', 'resolve', result);
          let formatted = this.endSearch(result.data);
          resolve(formatted);
        }).catch((err) => {
          this.endSearch(null);
          this.autoOn = false;
          this.api.handleError(err);
        });
      } catch (ex) {
        this.logger.log('carriers-search.service', 'catch', ex);
        return reject(ex);
      }
    });
  }

  endSearch(data: any): any {
    this.loaderOn = false;

    try {
      let formatted = new Array<Carrier>();

      for (let current = 0; current < data.items.length; current++) {
        formatted.push(new Carrier(data.items[current]));
      }

      return formatted;
    } catch (ex) {
      this.noResult = true;
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/search/carriers-search/carriers-search.service.ts